/****************************************************************************************
 * File Name    : DeleteCSImage.vue
 * Function     :
 * Author       : 최명호
 * Tester       :
 * Page         :
 * Target       :
 * Description  :
 * Modification Log
 * ======================================================================================
 * Ver  Date        	Author     	Modification
 * ======================================================================================
   1.0  2021.04.16  	최명호    	Create
****************************************************************************************/
<template>
        <div class = 'div_factory delete-image-form-container'>
            <!--  -->
            <a-form :form="form" @submit="onSubmit">
                <a-card>
                    <a-form-item label="날짜 (이 날짜 이전에 저장된 이미지를 삭제함)">
                        <date-picker v-model="date" valueType="format" required></date-picker>
                    </a-form-item>
                </a-card>
                <!--  -->
                <p/>
                <a-button type="danger" html-type="submit" :ghost = false size = "default" icon = "plus-circle">삭제</a-button>
                <div id="delete-message"></div>
            </a-form>

            <div v-show="showPasswordCheck" class="password-check">
                
                    <a-card style="margin: 30px auto; width: 400px;">
                        <a-form-item label="비밀번호">
                            <a-input placeholder="비밀번호" autocomplete="off" v-model="admin_password" @keyup="passwordKeyUp" />
                        </a-form-item>
                        <p/>
                        <a-button type="primary" html-type="button" :ghost = false size = "default" @click="onPasswordSubmit">비밀번호 확인</a-button>
                    </a-card>
                
            </div>
  <!--  -->
        </div>
</template>
<script>
import DatePicker from 'vue2-datepicker';

export default {
    name: 'DeleteCSImage',
    components: {
        DatePicker,
    },
    data() {
        return {
            showPasswordCheck: true,
            date: null,
        };
    },
    mounted() {

    },
    methods : {

        onSubmit(e) {
            e.preventDefault();
            if (!this.date) {
                this.$message.error('날짜를 선택하세요');
                return;
            }

            if (confirm('삭제하시겠습니까?')) {
                document.getElementById('delete-message').innerHTML = '삭제를 진행중입니다.';
                this.$http.get(this.$store.state.nodeApiUrl + '/product/cs/delete_cs_image/?date=' + this.date)
                    .then((response) => {
                        if (response.status === 200 && response.statusText === 'OK') {
                            this.$message.success(response.data.message);
                            document.getElementById('delete-message').innerHTML = '삭제가 완료되었습니다.';
                        }
                    });
            }
        },

        passwordKeyUp(e) {
            e.preventDefault();
            if (e.keyCode === 13) {
                this.onPasswordSubmit();
            }
        },

        onPasswordSubmit() {
            let password = sessionStorage.getItem('user_number');

            if (this.admin_password === password) {
                this.showPasswordCheck = false;
            } else {
                this.$message.error('비밀번호가 틀립니다.');
            }
        },
    }
}
</script>
<style scoped>
    .div_factory {
        text-align : left
    }
    #components-form-demo-vuex .language-bash {
        max-width: 400px;
        border-radius: 6px;
        margin-top: 24px;
    }
    .ant-form-item  {
        margin-bottom: 5px !important;
    }
    .ant-form-item-label  {
        font-weight: 700  !important;
    }

</style>